import React from "react";
import { Modal, Form, Select, Checkbox, Button } from "antd";
import { useTranslation } from "react-i18next";

interface Props {
  visible: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  loading: boolean;
  form: any;
}

const ExportModal: React.FC<Props> = ({
  visible,
  onCancel,
  onSubmit,
  loading,
  form,
}) => {
  const { t } = useTranslation("docProcessingCodes");
  const { t: tCommon } = useTranslation("common");
  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      onOk={onSubmit}
      title={t("exportModal.title")}
      width={600}
      footer={null}
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          label={t("exportModal.formatLabel")}
          name="exportFormat"
          rules={[{ required: true, message: t("exportModal.formatRequired") }]}
        >
          <Select
            placeholder={t("exportModal.formatPlaceholder")}
            options={[
              { label: t("exportModal.formatPdf"), value: "pdf" },
              { label: t("exportModal.formatWord"), value: "word" },
              { label: t("exportModal.formatExcel"), value: "excel" },
              { label: t("exportModal.formatRichText"), value: "richtext" },
            ]}
          />
        </Form.Item>
        <Form.Item name="includeExcerpt">
          <Checkbox>{t("exportModal.includeExcerpt")}</Checkbox>
        </Form.Item>
        <div className="buttonContainer">
          <Button onClick={onCancel}>{tCommon("cancel")}</Button>
          <Button type="primary" onClick={onSubmit} loading={loading}>
            {tCommon("submit")}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ExportModal;
